import { getCurrentInstance, onBeforeUnmount, onMounted, watch, ref, type Ref } from 'vue'

export function useAbbotListsAnimate(section: Ref<string>, detailId: Ref<number>) {
  let abbotRef = ref<HTMLDivElement>()

  onMounted(() => {
    abbotRef.value = <HTMLDivElement>getCurrentInstance()?.refs.abbotRef
    const elements = abbotRef.value?.querySelectorAll<HTMLButtonElement>('.name-button')
    elements?.forEach((e) => e.addEventListener('animationend', handleAnimationEnd))
  })

  onBeforeUnmount(() => {
    const elements = abbotRef.value?.querySelectorAll<HTMLButtonElement>('.name-button')
    elements?.forEach((e) => e.removeEventListener('animationend', handleAnimationEnd))
  })

  function clearAllBlinkAnimate() {
    const elements = abbotRef.value?.querySelectorAll<HTMLButtonElement>('.name-button')
    elements?.forEach((e) => e.classList.remove('blink'))
  }

  function setBlinkAnimate(dataId: number) {
    const el = abbotRef.value?.querySelector<HTMLButtonElement>(`.name-button[data-id=\'${dataId}\']`)
    el?.classList.add('blink')
  }

  function handleUpdateLists() {
    const nextId = detailId.value >= 8 ? 1 : detailId.value + 1
    clearAllBlinkAnimate()
    setBlinkAnimate(nextId)
  }

  function handleAnimationEnd(event: AnimationEvent) {
    const el = <HTMLButtonElement>event.currentTarget
    const id = Number(el.dataset.id)
    const nextId = id >= 8 ? 1 : id + 1
    clearAllBlinkAnimate()
    setBlinkAnimate(nextId)
  }

  watch(section, () => {
    // console.log('watch section', { section: section.value, detailId: detailId.value })
    if (section.value == 'lists') {
      handleUpdateLists()
    }
  })
}

//------------------------------------------------
